import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { newsArticles } from '../../data/newsArticles';
const NewsTicker = () => {
  // Get the latest 5 news articles
  const newsItems = newsArticles.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 5).map(article => ({
    id: article.id,
    text: article.title,
    link: `/news/${article.slug}`
  }));
  const [isPaused, setIsPaused] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const tickerRef = useRef<HTMLDivElement>(null);
  const handlePrev = () => {
    setCurrentIndex(prev => prev === 0 ? newsItems.length - 1 : prev - 1);
  };
  const handleNext = () => {
    setCurrentIndex(prev => prev === newsItems.length - 1 ? 0 : prev + 1);
  };
  // Auto-advance the ticker
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused, currentIndex]);
  return <div className="bg-blue-900 py-3 text-white shadow-md relative z-10" data-id="element-250">
      <div className="container mx-auto px-4" data-id="element-251">
        <div className="flex items-center" data-id="element-252">
          <div className="bg-yellow-500 text-blue-900 font-bold py-1 px-3 rounded-full mr-4 whitespace-nowrap flex items-center" data-id="element-253">
            <BellIcon className="h-4 w-4 mr-1 animate-bounce-slow" data-id="element-254" />
            <span data-id="element-255">Latest News</span>
          </div>
          <div className="overflow-hidden flex-grow relative" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} ref={tickerRef} data-id="element-256">
            <div className="flex items-center h-8" data-id="element-257">
              <div className="animate-fadeIn absolute w-full transition-opacity duration-500" data-id="element-258">
                <Link to={newsItems[currentIndex].link} className="hover:text-yellow-300 transition-colors" data-id="element-259">
                  {newsItems[currentIndex].text}
                </Link>
              </div>
            </div>
          </div>
          <div className="flex items-center ml-4 space-x-2" data-id="element-260">
            <button onClick={handlePrev} className="p-1 hover:bg-blue-800 rounded-full transition-colors" aria-label="Previous news" data-id="element-261">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-262" />
            </button>
            <button onClick={handleNext} className="p-1 hover:bg-blue-800 rounded-full transition-colors" aria-label="Next news" data-id="element-263">
              <ChevronRightIcon className="h-5 w-5" data-id="element-264" />
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default NewsTicker;